import ReportUtils from "../../../../../../utils/report-utils.js";
import {useMemo, useState} from "react";
import {AgGridReact} from "ag-grid-react";
import AgGridUtils from "../../../../../../utils/aggrid-utils.js";
import PrintableTableAgGrid from "../../../../../../components/printable-table/printable-table-ag-grid.jsx";
import aggridUtils from "../../../../../../utils/aggrid-utils.js";

export default function AgentDependents({ data }) {
    const dependents = data?.dependents ?? {};
    const [gridApi, setGridApi] = useState(null);

    const dependentsMap = {
        pai: "Pai",
        mae: "Mãe",
        filho: "Filho",
        filha: "Filha",
        enteado: "Enteado",
        enteada: "Enteada",
        irmao: "Irmão",
        irma: "Irmã",
        neto: "Neto",
        neta: "Neta",
    }

    const columnDefs = useMemo(() => ([
        { headerName: "Nome", field: "dependentName", flex: 1},
        { headerName: "Parentesco", field: "kinship", flex: 1, valueFormatter: ({value}) => dependentsMap[value] },
        { headerName: "Nascimento", field: "dependentBirth", flex: 1, valueFormatter: ({value}) => ReportUtils.formatDateOnly(value) }
    ]), [dependents])

    return (
        <div className="space-y-4">
            <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] mb-2">
                Dependentes
            </h2>

            <div className="w-full print:hidden mb-6">
                <AgGridReact
                    rowData={dependents ?? {}}
                    columnDefs={columnDefs}
                    defaultColDef={{ resizable: false }}
                    animateRows={false}
                    suppressCellFocus={true}
                    gridOptions={{ localeText: AgGridUtils.localization() }}
                    theme={aggridUtils.generalTheme()}
                    onGridReady={(params) => setGridApi(params.api)}
                    domLayout="autoHeight"
                />
            </div>

            <div className="hidden print:block rounded-[8px] overflow-hidden border border-[#e0e1e3] mb-6">
                <PrintableTableAgGrid
                    formatters={{
                        kinship: (row) => dependentsMap[row.kinship],
                        dependentBirth: (row) => ReportUtils.formatDateOnly(row.dependentBirth)
                    }}
                    gridApi={gridApi}
                    className="border-0! w-full -my-px"
                    thClassName="first:!border-l-0 last:!border-r-0 text-[#676a6c]"
                    tdClassName="first:!border-l-0 last:!border-r-0"
                />
            </div>
        </div>
    )
}